/**
 * Best human-readable message for a failed coordinate lookup.
 *
 * The server sends the failure `error` as a descriptive string that names the
 * catalogs it checked (e.g. "Couldn't resolve \"ASASSN-26fz\". Checked SIMBAD,
 * VSX, VizieR/Sesame, NED — no match. …"). This helper prefers that message, but
 * also tolerates an { message } object or a bare axios error, so callers never
 * surface "[object Object]" or a generic "Request failed with status code 404".
 */
export function lookupErrorText(err, fallback = 'Lookup failed') {
  const data = err && err.response && err.response.data;
  const e = data && data.error;
  if (typeof e === 'string' && e.trim()) return e.trim();
  if (e && typeof e === 'object' && typeof e.message === 'string' && e.message.trim()) {
    return e.message.trim();
  }
  if (data && typeof data.message === 'string' && data.message.trim()) return data.message.trim();
  if (err && typeof err.message === 'string' && err.message.trim()) return err.message.trim();
  return fallback;
}

/**
 * Message for an in-band lookup response that came back 2xx but unresolved
 * (`{ success:false, error }`). Kept separate from lookupErrorText, which unwraps
 * a thrown axios error.
 */
export function lookupResponseErrorText(resp, fallback = 'Target not found') {
  const e = resp && resp.error;
  if (typeof e === 'string' && e.trim()) return e.trim();
  if (e && typeof e === 'object' && typeof e.message === 'string' && e.message.trim()) {
    return e.message.trim();
  }
  return fallback;
}
